/**
 * Domain Configuration
 * This file is auto-generated based on the DOMAIN_NAME environment variable
 * Used to replace {{DOMAIN_NAME}} placeholders in locale files
 * 
 * Generated at: 2026-11-03T19:45:24.885Z
 */

// Domain name from environment variable (set at build time)
export const DOMAIN_NAME = 'meet-latina-australia.de'

export default DOMAIN_NAME
